var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"finishApply"},[_c('img',{staticClass:"applysuc_img",attrs:{"src":require("../../assets/images/ic-xfcg.png")}}),_c('p',{staticClass:"tips"},[_vm._v("入驻申请已提交"),_c('br'),_vm._v("审核结果将以短信发送"),_c('br'),_c('span',{staticClass:"view_btn"},[_vm._v("请注意查收短信")])])])
}]

export { render, staticRenderFns }